import api from './api';

const API_BASE = '/api/study-promotion';

// Seeded against the StudyBuildDeployment content type (FECOA-1918), so the
// dotted app-namespaced form is what the permission check endpoint needs.
export const PROMOTE_STUDY_BUILD_PERMISSION = 'study_promotion.can_promote_study_build';

// Downloads the candidate package exactly as the server serialized it (the
// checksum is the sign-off artifact, so the file bytes are kept server-authored).
export const downloadStudyBuild = async (studyId, label, fallbackName = 'candidate.fxbuild.json') => {
  const response = await api.get(`${API_BASE}/studies/${studyId}/export/`, {
    params: { label },
    responseType: 'blob',
  });
  const disposition = response.headers?.['content-disposition'] || '';
  const match = disposition.match(/filename="([^"]+)"/);
  const url = URL.createObjectURL(response.data);
  const a = document.createElement('a');
  a.href = url;
  a.download = match ? match[1] : fallbackName;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};

export const preflightPackage = async (file) => {
  const formData = new FormData();
  formData.append('file', file);
  const response = await api.post(`${API_BASE}/preflight/`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data;
};

export const deployPackage = async (file) => {
  const formData = new FormData();
  formData.append('file', file);
  const response = await api.post(`${API_BASE}/deploy/`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data;
};

export const getDeploymentHistory = async (params = {}) => {
  const response = await api.get(`${API_BASE}/deployments/`, { params });
  return response.data;
};

// FECOA-1920. Re-exports the deployed study in this environment and compares it
// section by section against the candidate that produced it. Safe to re-run at
// any time: the only thing written is the verification record itself.
export const verifyDeployment = async (deploymentId) => {
  const response = await api.post(`${API_BASE}/deployments/${deploymentId}/verify/`);
  return response.data;
};

export const getVerificationHistory = async (deploymentId) => {
  const response = await api.get(`${API_BASE}/deployments/${deploymentId}/verify/`);
  return response.data;
};

// Blob-typed error responses (from the download endpoint) need decoding
// before their error message is readable.
export const readErrorMessage = async (err, fallback) => {
  const data = err?.response?.data;
  if (data instanceof Blob) {
    try {
      const parsed = JSON.parse(await data.text());
      return parsed.error || fallback;
    } catch {
      return fallback;
    }
  }
  return data?.error || data?.detail || fallback;
};
